import React from 'react';
import { BusinessRuleIssueType } from '@chiroup/core';
import { Link } from 'react-router-dom';

interface Props {
  issue: BusinessRuleIssueType;
}

const pathToString = (path: string[]) => {
  return '"' + path.join('" => "') + '"';
};

const BusinessRuleIssue: React.FC<Props> = ({ issue }) => {
  return (
    <div className="mx-4 my-2 p-2 rounded-lg bg-white border border-gray-400 relative">
      <div className="font-medium">{issue.text}</div>
      {issue.path ? <div>{pathToString(issue.path)}</div> : null}
      {issue.url ? (
        <div className="absolute top-0 right-0 text-primary-500 hover:text-gray-800 focus:ring-4 font-medium rounded-lg text-sm px-2.5 py-2.5 me-2 mb-2 ">
          <Link to={issue.url} target="_blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
              />
            </svg>
          </Link>
        </div>
      ) : null}
    </div>
  );
};

export default BusinessRuleIssue;
